import React from 'react'
import { Helmet } from 'react-helmet-async'
import { PlanChangeLayout } from '../../layouts/Billing'

const Comp = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Plan Change</title>
      <meta name="description" content="Plan change page" />
    </Helmet>
    <PlanChangeLayout />
  </React.Fragment>
)

export default Comp
